/**
 * Schritt 2 des Workload-Steckbriefs (NC-1279): Verantwortung.
 */

import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { WorkloadProfileInput, ProfileContact } from '../../../services/types';
import { ProfileStepProps } from './types';

const EMPTY_CONTACT: ProfileContact = { name: '', role: '', email: '' };

export default function ProfileStepOwnership({ value, onChange }: ProfileStepProps) {
  const set = (patch: Partial<WorkloadProfileInput['ownership']>) =>
    onChange({ ...value, ownership: { ...value.ownership, ...patch } });

  const setContact = (patch: Partial<ProfileContact>) =>
    set({ contact: { ...value.ownership.contact, ...patch } });

  const setDeputy = (patch: Partial<ProfileContact>) =>
    set({ deputy: { ...(value.ownership.deputy ?? EMPTY_CONTACT), ...patch } });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h6">Verantwortung</Typography>

      <Typography variant="subtitle2">
        Fachlicher Ansprechpartner — entscheidet über Inhalte und Software-Versionen
      </Typography>
      <TextField label="Name" fullWidth
        value={value.ownership.contact.name}
        onChange={(e) => setContact({ name: e.target.value })} />
      <TextField label="Rolle" fullWidth
        value={value.ownership.contact.role}
        onChange={(e) => setContact({ role: e.target.value })} />
      <TextField label="E-Mail" type="email" fullWidth
        value={value.ownership.contact.email}
        onChange={(e) => setContact({ email: e.target.value })} />

      <Typography variant="subtitle2">Stellvertretung (optional)</Typography>
      <TextField label="Name Stellvertretung" fullWidth
        value={value.ownership.deputy?.name ?? ''}
        onChange={(e) => setDeputy({ name: e.target.value })} />
      <TextField label="E-Mail Stellvertretung" type="email" fullWidth
        value={value.ownership.deputy?.email ?? ''}
        onChange={(e) => setDeputy({ email: e.target.value })} />

      <TextField label="Auftraggeber / Fachbereich" fullWidth
        value={value.ownership.department}
        onChange={(e) => set({ department: e.target.value })} />
      <TextField label="Kostenstelle" fullWidth
        helperText="Code der Kostenstelle, auf die Schulungen dieses Workloads gebucht werden."
        value={value.ownership.costCenterCode}
        onChange={(e) => set({ costCenterCode: e.target.value })} />
    </Box>
  );
}
